import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Opportunities } from './pages/Opportunities';
import { JobDetail } from './pages/JobDetail';
import { Employers } from './pages/Employers';
import { Insights } from './pages/Insights';
import { Dashboard } from './pages/Dashboard';
import { Firm } from './pages/Firm';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2riko97zkgfcl">
      <Layout data-id="element-1" data-mp="2mm2lgdnsqr2w">
        <Routes data-id="element-2" data-mp="2mmlt91jqfz37">
          <Route path="/" element={<Home data-id="element-4" data-mp="2mnng03a42a0r" />} data-id="element-3" data-mp="2mmvob3jmwwfr" />
          <Route path="/opportunities" element={<Opportunities data-id="element-6" data-mp="31ayqs2ygxpzt" />} data-id="element-5" data-mp="2mjzmv58kvpmk" />
          <Route path="/opportunities/:id" element={<JobDetail data-id="element-8" data-mp="2wk06yte9u9rt" />} data-id="element-7" data-mp="31c9u61o04vqe" />
          <Route path="/employers" element={<Employers data-id="element-10" data-mp="2wip5x1c7ng4e" />} data-id="element-9" data-mp="2wjqff1dkvuk0" />
          <Route path="/firm" element={<Firm data-id="element-12" data-mp="28tw9l3rof699" />} data-id="element-11" data-mp="2wi5pxq64f1t0" />
          <Route path="/insights" element={<Insights data-id="element-14" data-mp="28sb9yzqi8x4j" />} data-id="element-13" data-mp="28t4mkhc5agul" />
          <Route path="/dashboard" element={<Dashboard data-id="element-16" data-mp="23u9v6r043jyv" />} data-id="element-15" data-mp="23vkw8j26adma" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}